import { useQuery } from 'react-query';

import { PromptTemplateResponseDto } from '../../../../backend/src/prompt-template/dto/prompt-template.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetPromptTemplates = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const fetcher = useFetcher();

  return useQuery<PromptTemplateResponseDto[]>(
    [QueryEntity.PromptTemplates],
    () => fetcher(`${APIBaseChronos}/api/prompt-template`),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );
};
